import Firebase from "firebase";
import router from "@/router";
import VueCookies from "vue-cookies";

const state = {
  userData: {
    nome: "Usuário"
  },
  userUID: VueCookies.get("USERTOKEN"),
  error: null
};

const mutations = {
  setUserData: (state, payload) => {
    state.userData = payload;
  },
  setError(state, payload) {
    state.error = payload;
  }
};

const actions = {
  login: async (context, user) => {
    await Firebase.auth()
      .signInWithEmailAndPassword(user.email, user.senha)
      .then(
        async () => {
          await context.dispatch("getInitialUserDataInFirestore");
          router.push("/");
        },
        err => context.commit("setError", err.message)
      );
  },

  getInitialUserDataInFirestore: async context => {
    let _user = Firebase.auth().currentUser.uid;

    await Firebase.firestore()
      .collection("users")
      .doc(_user)
      .get()
      .then(async doc => {
        await doc
          .data()
          ._associado.get()
          .then(async socio => {
            await VueCookies.set("USERTOKEN", socio.data()._id, "0");
            context.commit("setUserData", socio.data());
            await VueCookies.set("IDASSOCIACAO", Object.keys(socio.data().associacoes)[0], "0");
        });
    });
  },

  getUserDataInFirestore: async context => {
    let _associado = VueCookies.get("USERTOKEN");
    await Firebase.firestore()
      .collection("associados")
      .doc(_associado)
      .get()
      .then(doc => {
        context.commit("setUserData", doc.data());

        if (!VueCookies.get("IDASSOCIACAO"))
            VueCookies.set("IDASSOCIACAO", Object.keys(doc.data().associacoes)[0], "0");
    });
  },

  signUp: (email, password) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(user => user, err => err);
  },

  logout: () => {
    Firebase.auth()
      .signOut()
      .then(() => {
        VueCookies.remove("USERTOKEN");
        VueCookies.remove("IDASSOCIACAO");
        sessionStorage.removeItem("contas");
        router.push("/login");
      })
      .catch(function(error) {
        console.log("Erro ao deslogar", error);
      });
  }
};

const getters = {
  getUserData: state => state.userData
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
